module.exports = __webpack_public_path__ + "img/dance-school-icon3.c7218bb8.png";